import { useEffect, useState } from "react";
import { CoreFileItem } from "./FileCard";

/**Resolves a {@link CoreFileItem} to a displayable URL: the persisted `url` if present,
 * otherwise an object URL created from `nativeFile`. Object URLs are revoked on cleanup. */
export default function useFileUrl(file?: CoreFileItem): string | undefined {
	const [blobUrl, setBlobUrl] = useState<string>();

	useEffect(() => {
		if (file?.url || !file?.nativeFile) {
			setBlobUrl(undefined);
			return;
		}

		const url = URL.createObjectURL(file.nativeFile);
		setBlobUrl(url);

		return () => {
			URL.revokeObjectURL(url);
			setBlobUrl(undefined);
		};
	}, [file]);

	return file?.url ?? blobUrl;
}
